import { useTheme } from "@material-ui/core"
import { Check, Eye, EyeOff, Square } from "react-feather"

export const isGanttRoute = (pathname: string) => pathname.includes("gantt")
export const isBasicRoute = (pathname: string) => pathname.includes("basic")
export const isTasksRoute = (pathname: string) => pathname.includes("tasks")
export const isKanbanRoute = (pathname: string) => pathname.includes("kanban")
export const isTodoListRoute = (pathname: string) => pathname.includes("todos")
export const isCalendarRoute = (pathname: string) => pathname.includes("calendar")
export const isDashboardRoute = (pathname: string) => pathname.includes("dashboard")
export const isReportedHoursRoute = (pathname: string) => pathname.includes("reported-hours")

export const projectTabsOrder = [
  "basic",
  "gantt",
  "tasks",
  "todos",
  "calendar",
  "kanban",
  "reported-hours",
  "dashboard",
  "chat",
] as const

export type ProjectTab = (typeof projectTabsOrder)[number]

export const getActiveTabIndex = (pathname: string, visibleTabs: readonly ProjectTab[] = projectTabsOrder) => {
  const activeTab = projectTabsOrder.find((tab) => pathname.includes(tab))
  if (!activeTab) return 0

  const index = visibleTabs.indexOf(activeTab)
  if (index === -1) return false

  return index
}

export const EyeIcon = ({ isShown, size = 20 }: { isShown: boolean; size?: number }) => {
  if (isShown) return <EyeOff size={size} />
  else return <Eye size={size} />
}

export const CheckIcon = ({ isChecked }: { isChecked: boolean }) => {
  const theme = useTheme()
  const style = { background: theme.palette.primary.main, stroke: theme.palette.common.white, borderRadius: 3 }

  if (isChecked) {
    return <Check style={style} size={16} />
  } else {
    return <Square size={18} />
  }
}
